var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "audit-create" }, [
    _c("div", { staticClass: "topbar" }, [
      _c(
        "div",
        { staticClass: "back", on: { click: _vm.handleBack } },
        [
          _vm._t("back-btn", function () {
            return [
              _c("yxt-svg", {
                attrs: {
                  width: "16px",
                  height: "16px",
                  "icon-class": "page-header-back-arrow",
                },
              }),
              _c("span", { staticClass: "back-text" }, [
                _vm._v(
                  _vm._s(_vm.info.baseInfo && _vm.info.baseInfo.tmplName) +
                    _vm._s(_vm.$t("pc_audit"))
                ),
              ]),
            ]
          }),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "steps" },
        _vm._l(_vm.steps, function (it, i) {
          return _c(
            "div",
            {
              key: it.key,
              staticClass: "step",
              class: [
                _vm.activeIndex === i ? "text-26" : "text-8c",
                {
                  active: _vm.activeIndex === i,
                },
              ],
            },
            [
              _c("div", { staticClass: "title" }, [
                _vm.activeIndex > i
                  ? _c(
                      "svg",
                      {
                        staticClass: "icon",
                        attrs: {
                          width: "21px",
                          height: "20px",
                          viewBox: "0 0 21 20",
                          version: "1.1",
                          xmlns: "http://www.w3.org/2000/svg",
                          "xmlns:xlink": "http://www.w3.org/1999/xlink",
                        },
                      },
                      [
                        _c(
                          "g",
                          {
                            attrs: {
                              transform: "translate(4.048087, 4.000000)",
                              fill: "#436BFF",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M2.18256578,4.79025433 C2.24114721,4.73167568 2.33612647,4.73167568 2.39470789,4.79025433 L4.93988286,7.33530841 L9.60753964,2.66893398 C9.66612106,2.61035534 9.76110032,2.61035534 9.81968175,2.66893398 L10.6682502,3.51746212 C10.7268316,3.57604076 10.7268316,3.67101551 10.6682502,3.72959415 L5.04648427,9.35109307 C4.98790284,9.40967171 4.89292359,9.40967171 4.83434216,9.35109307 L1.33399734,5.8509145 C1.27541592,5.79233585 1.27541592,5.69736111 1.33399734,5.63878246 L2.18256578,4.79025433 Z",
                                id: "路径",
                              },
                            }),
                          ]
                        ),
                      ]
                    )
                  : _c(
                      "i",
                      {
                        staticClass: "icon",
                        class: [
                          "bg-gray-4",
                          {
                            active: _vm.activeKey === it.key,
                            "color-white": _vm.activeKey === it.key,
                          },
                        ],
                      },
                      [_vm._v(_vm._s(it.key))]
                    ),
                _c("span", { staticClass: "name" }, [
                  _vm._v("\n            " + _vm._s(it.name) + "\n          "),
                ]),
              ]),
              _c("yxt-svg", {
                staticClass: "arrow",
                attrs: {
                  width: "16px",
                  height: "16px",
                  "icon-class": "icons/arrow-right",
                },
              }),
            ],
            1
          )
        }),
        0
      ),
      _c("div", { staticClass: "none" }),
    ]),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "step-con yxt-layout__root",
      },
      [
        _vm.activeIndex === 0
          ? _c("StepTwo", {
              ref: "stepTwoRef",
              attrs: {
                connects: _vm.info.connects,
                "node-list": _vm.info.nodeList,
                "tmpl-code": _vm.tmplCode,
                "is-edit": _vm.isEdit,
              },
            })
          : _vm._e(),
        _vm.activeIndex === 1
          ? _c("StepEnd", {
              ref: "stepEndRef",
              attrs: {
                "tmpl-setting": _vm.info.tmplSetting,
                "is-edit": _vm.isEdit,
              },
            })
          : _vm._e(),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "audit-footer" },
      [
        _vm.activeIndex > 0
          ? _c("yxt-button", { on: { click: _vm.handlePrev } }, [
              _vm._v(_vm._s(_vm.$t("pc_prev_btn"))),
            ])
          : _vm._e(),
        _vm.activeIndex < 1
          ? _c(
              "yxt-button",
              {
                attrs: { disabled: _vm.loading, type: "primary" },
                on: { click: _vm.handleNext },
              },
              [_vm._v(_vm._s(_vm.$t("pc_next_step")))]
            )
          : _c(
              "yxt-button",
              {
                attrs: { loading: _vm.confirmPading, type: "primary" },
                on: { click: _vm.handleOk },
              },
              [_vm._v(_vm._s(_vm.$t("pc_save")))]
            ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }